import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { DoctorProfileReducer } from "./DoctorProfileReducer"
import { AccountDataReducer } from "./AccountDataReducer"
import { AppointmentsReducer } from "./AppointmentsReducer"
import { PatientCompleteInfoReducer } from "./PatientCompleteInfoReducer"
import { OngoingConsultationReducer } from "./OngoingConsultationReducer";
import { CenterInfoReducer } from "./CenterInfoReducer";
import { AllStaticDataReducerNew } from "./AllStaticDataReducerNew";
import { ChatAndVideoAccessTokenReducer } from "./ChatAndVideoAccessTokenReducer";
import { TwilioContextReducer } from "./TwilioContextReducer";
import { AllAppointmentsReducer } from "./AllAppointmentsReducer";
import { IAppState } from "../models/IAppState";
import initialState from "./InitialState";
import { ManagedPlanPatientsReducer } from "./ManagedPlanPatientsReducer";
import { ModalReducer } from "./ModalReducer";
import { EditPrescriptionReducer } from "./EditPrescriptionReducer";
import { overrideReducer } from "./OverrideReducer";
import { FeatureConfigInfoReducer } from "./FeatureConfigInfoReducer";
import { CovidReducer } from "./CovidReducer";
import { UserFormReducer } from "./UserformReducer";
import { StaticTreatmentPlanReducer } from "./StaticTreatmentPlanReducer";
import * as createLogger from "redux-logger";
import thunk from "redux-thunk";
import { UserFitnessReducer } from "./UserFitnessReducer";
import { WhatsAppChatContextReducer } from "./WhatsAppChatContextReducer";

export const RootReducer = combineReducers({
    accountData: AccountDataReducer,
    doctorProfile: DoctorProfileReducer,
    appointments: AppointmentsReducer,
    allAppointments: AllAppointmentsReducer,
    patientCompleteInfo: PatientCompleteInfoReducer,
    allStaticDataNew: AllStaticDataReducerNew,
    ongoingConsultation: OngoingConsultationReducer,
    centerInfo: CenterInfoReducer,
    chatAndVideoAccessTokens: ChatAndVideoAccessTokenReducer,
    mpPatientsData: ManagedPlanPatientsReducer,
    twilioContext: TwilioContextReducer,
    whatsAppChatContext: WhatsAppChatContextReducer,
    responseData: ModalReducer,
    editPrescription: EditPrescriptionReducer,
    overrides: overrideReducer,
    featureConfigInfo: FeatureConfigInfoReducer,
    covidInfo: CovidReducer,
    userform: UserFormReducer,
    treatmentPlanReducer: StaticTreatmentPlanReducer,
    fitnessData: UserFitnessReducer
});

const AllReducer = (state: IAppState, action: any) => {
    if (action.type === "RESET_STORE") {
        state = initialState;
    }

    return RootReducer(state, action);
};

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
    AllReducer,
    composeEnhancers(applyMiddleware(thunk, (createLogger as any)()))
);